module.exports = __webpack_public_path__ + "static/media/slide1-mobile.20b09fd7.jpg";